package com.essntl.core.settings.data.supabase.configuration

import com.essntl.core.settings.domain.model.configuration.ConfigurationModel
import kotlinx.serialization.json.*

internal fun ConfigurationModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    requestMap["setting_key"] = JsonPrimitive(settingKey)

    requestMap["setting_value"] = settingValue

    return requestMap
}
